<div class="m-portlet">
    <div class="m-form">
        <div class="m-portlet__body">
            <a *ngIf="data.link !== undefined && data.link != ''" href="data.link" target="_blank">
                <img style="width: 100%; height: auto;" [src]="data.pathOrbase64string" />
            </a>
            <img *ngIf="data.link === ''" style="width: 100%; height: auto;" [src]="data.pathOrbase64string" />
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
            <div class="m-form__actions m-form__actions--sm">
                <button color="accent" mat-raised-button mat-dialog-close (click)="kapat()">Kapat</button>&nbsp;
            </div>
        </div>
    </div>
</div>